module.exports = __webpack_public_path__ + "img/mark.eb977bd3.svg";